import { Indicator } from '../../../Common/Charts/Indicator';
import { useGeneralResultsChartsDataContext } from './hooks/useGeneralResultsChartsDataContext';

export const MothersLessThan6PrenatalConsultations = () => {
    const { chartData } = useGeneralResultsChartsDataContext();

    return (
        <Indicator
            title={'Mães com menos de 6 consultas pré-natais'}
            indicatorValue={chartData?.indicators?.mothersLessThan6PrenatalConsultations}
            className='aligned-container'
        />
    );
};
